import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const createReportItemsSelector = (state: AppState) => state.frontendState.createReport.items;
export const useCreateReportItemsSelector = () => useSelector(createReportItemsSelector);
